module.exports = __webpack_public_path__ + "6ea53404668ed5ef30f446b053e475a9.png";